import React, { useState } from 'react';
import RankingCard from './RankingCard';
import RankingControls from './RankingControls';
import LoadingMatchup from './LoadingMatchup';
import { useRankingGame } from '../../hooks/useRankingGame';
import { QUESTION_TEXT } from '../../utils/ranking';

const RankingGame = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { 
    currentPair, 
    currentType,
    error,
    submitVote,
    skipMatchup
  } = useRankingGame();

  const handleVote = async (winnerId: string | null, isTie = false) => {
    try {
      setIsLoading(true);
      await submitVote(winnerId, isTie);
      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (err) {
      console.error('Vote error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  if (error) {
    return (
      <div className="text-center">
        <p className="text-red-400 mb-4">{error.message}</p>
        <button onClick={() => skipMatchup()} className="btn-primary">
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col gap-2">
      {/* Question Section */}
      <div className="bg-gradient-to-r from-brand/5 via-brand/10 to-brand/5 rounded-lg p-2 border border-brand/20 text-center">
        <h2 className="text-lg font-semibold text-content-primary">
          {QUESTION_TEXT[currentType]}
        </h2>
      </div>

      {/* Game UI */}
      <div className="flex-1 relative min-h-0">
        {isLoading && <LoadingMatchup />}
        <div className="h-full flex flex-col">
          {/* Cards Container - Updated for better mobile layout */}
          <div className="flex-1 grid grid-cols-2 gap-2 sm:gap-4 pb-2">
            {currentPair ? (
              <>
                <div className="flex flex-col justify-center">
                  <RankingCard
                    animatronic={currentPair.animatronic_a}
                    onSelect={() => handleVote(currentPair.animatronic_a.id)}
                    isLoading={isLoading}
                  />
                </div>
                <div className="flex flex-col justify-center">
                  <RankingCard
                    animatronic={currentPair.animatronic_b}
                    onSelect={() => handleVote(currentPair.animatronic_b.id)}
                    isLoading={isLoading}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="aspect-square sm:aspect-[4/3] bg-background-secondary rounded-lg animate-pulse" />
                <div className="aspect-square sm:aspect-[4/3] bg-background-secondary rounded-lg animate-pulse" />
              </>
            )}
          </div>
          
          {/* Controls - Updated for better mobile spacing */}
          <div className="mt-auto pt-2 px-2">
            <RankingControls
              onTie={() => handleVote(null, true)}
              onSkip={skipMatchup}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RankingGame;
